import React from 'react';
import { useNavigate } from 'react-router-dom';

const About = () => {
  const navigate = useNavigate();
  return (
    <div style={styles.container}>
      <div style={styles.wrapper}>

        {/* HERO SECTION */}
        <div style={styles.section}>
          <h1 style={styles.mainTitle}>ABOUT MILLION OR BUST</h1>
          <h2 style={styles.subtitle}>The Blue-Collar Blueprint to a Million Dollar Business.</h2>
          <p style={styles.text}>
            I built Million or Bust to be the first AI-native incubator designed specifically for the blue-collar workforce. I am bridging the gap from the shop floor to the CEO's desk using a proprietary 10-step system and advanced AI simulation.
          </p>
        </div>

        {/* THE MISSION */}
        <div style={styles.section}>
          <h3 style={styles.header}>THE MISSION</h3>
          <p style={styles.text}>
            Great ideas exist everywhere—in mechanic bays, Amazon warehouses, and construction sites—but the roadmap to execution is often hidden behind expensive degrees or complex jargon.
          </p>
          <p style={styles.text}>
            Million or Bust is my solution to democratize entrepreneurship. Based on over 500 hours of my own analysis into startup successes and failures, I have distilled the journey into a proven 10-Step System. My goal is absolute: take a user from $0 in the bank to a $1,000,000 valuation, regardless of their starting point.
          </p>
        </div>

        {/* THE TECHNOLOGY */}
        <div style={styles.section}>
          <h3 style={styles.header}>THE TECHNOLOGY: MEET "MILLION"</h3>
          <p style={styles.text}>
            At the heart of my platform is "Million," a context-aware AI architecture I engineered using Google Cloud and Gemini. "Million" is not just a chatbot; it is a proactive co-founder that manages user data, storage, and logic across the entire Web and Mobile ecosystem.
          </p>
        </div>

        {/* THE LABS */}
        <div style={styles.section}>
          <h3 style={styles.header}>THE LABS (CORE FEATURES)</h3>
          <p style={styles.text}>
            I replaced abstract theory with three dedicated production environments that I designed to solve specific founder pain points:
          </p>

          <div style={styles.subBlock}>
            <h4 style={styles.subHeader}>🧪 THE VIABILITY LAB</h4>
            <p style={styles.text}>
              Before a user writes code or buys inventory, I force them to test their concept against the market. "Million" helps identify industry gaps and locates the "Goldilocks Zone" of targeting—an audience that is niche enough to dominate but large enough to scale.
            </p>
          </div>

          <div style={styles.subBlock}>
            <h4 style={styles.subHeader}>🎥 THE CONTENT LAB</h4>
            <p style={styles.text}>
              I believe in organic growth. This lab helps users generate high-leverage video scripts and content strategies to utilize free advertising platforms, turning a smartphone into a marketing department.
            </p>
          </div>

          <div style={styles.subBlock}>
            <h4 style={styles.subHeader}>🤝 THE SALES LAB (AI SIMULATOR)</h4>
            <p style={styles.text}>
              I developed a state-of-the-art roleplay environment where users practice pitching against dynamic AI personas:
            </p>
            <ul style={styles.list}>
              <li><strong style={styles.highlight}>"Easy Pete":</strong> The friendly prospect I designed to test your ability to close without falling into "nice guy" traps.</li>
              <li><strong style={styles.highlight}>"Hard Mike":</strong> The skeptical negotiation partner designed to build resilience.</li>
              <li><strong style={styles.highlight}>Whisper Mode:</strong> While the user negotiates, "Million" provides real-time, whispered advice on screen, coaching the user on how to pivot, avoid stumbling, and close the deal.</li>
            </ul>
          </div>
        </div>

        {/* FOUNDER STORY */}
        <div style={styles.section}>
          <h3 style={styles.header}>THE FOUNDER STORY</h3>
          <h4 style={{ ...styles.subHeader, color: '#fff' }}>Joshua Brandon Morgan | Founder & Lead Engineer</h4>
          <p style={{ ...styles.text, fontStyle: 'italic', borderLeft: '3px solid var(--gold)', paddingLeft: '20px', margin: '20px 0' }}>
            "I don't come from Silicon Valley. I come from the work floor. I spent 13 years as a professional mechanic, mastering complex systems under the hood. Today, I work inside Amazon, moving boxes and seeing firsthand the grit of the American workforce. I realized that the only difference between the people moving the boxes and the people owning the company is a system."
          </p>
          <p style={styles.text}>
            I built Million or Bust to be that system. I am coding this platform in public, using the same 'Million or Bust' methodology I teach, to prove that with the right tech stack (React & Firebase) and the right work ethic, the transition from employee to entrepreneur is possible for anyone.
          </p>
        </div>

        <div style={{ textAlign: 'center', marginTop: '40px' }}>
          <button onClick={() => navigate('/')} style={styles.backBtn}>RETURN TO BASE</button>
        </div>

      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#000', color: '#fff', padding: '60px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  wrapper: { maxWidth: '800px', width: '100%' },
  section: { marginBottom: '50px', borderBottom: '1px solid #222', paddingBottom: '30px' },
  mainTitle: { fontFamily: 'Orbitron', color: 'var(--gold)', fontSize: '2.5rem', marginBottom: '10px', textAlign: 'center' },
  subtitle: { fontFamily: 'Orbitron', color: '#fff', fontSize: '1.2rem', marginBottom: '30px', textAlign: 'center', opacity: 0.8 },
  header: { fontFamily: 'Orbitron', color: 'var(--gold)', fontSize: '1.8rem', marginBottom: '20px', borderLeft: '4px solid var(--gold)', paddingLeft: '15px' },
  subHeader: { fontFamily: 'Orbitron', color: '#ccc', fontSize: '1.2rem', marginBottom: '10px' },
  text: { lineHeight: '1.8', fontSize: '1.1rem', color: '#ccc', marginBottom: '15px', fontFamily: 'Inter' },
  highlight: { color: 'var(--gold)' },
  subBlock: { background: '#0a0a0a', padding: '20px', borderRadius: '8px', marginBottom: '20px', border: '1px solid #222' },
  list: { listStyle: 'none', padding: 0, marginLeft: '10px' },
  backBtn: { background: 'transparent', border: '1px solid var(--gold)', color: 'var(--gold)', padding: '15px 40px', cursor: 'pointer', fontFamily: 'Orbitron', fontSize: '1rem', fontWeight: 'bold', transition: 'all 0.3s ease' }
};

export default About;
